import { type } from '@/utils/type'


export const ADMINFLEET_REQUEST = type('ADMINFLEET_REQUEST')
export const ADMINFLEET_SUCCESS = type('ADMINFLEET_SUCCESS')
export const ADMINFLEET_ERROR = type('ADMINFLEET_ERROR')

export const ADMINFLEET_ENSURE_LIST = type('ADMINFLEET_ENSURE_LIST')

export const ADMINFLEET_SELECT_DETAIL_REQUEST = type('ADMINFLEET_SELECT_DETAIL_REQUEST')
export const ADMINFLEET_SELECT_DETAIL_SUCCESS = type('ADMINFLEET_SELECT_DETAIL_SUCCESS')
export const ADMINFLEET_SELECT_DETAIL_ERROR = type('ADMINFLEET_SELECT_DETAIL_ERROR')
export const ADMINFLEET_SELECT_DETAIL = type('ADMINFLEET_SELECT_DETAIL')

export const ADMINFLEET_CONFIG_REQUEST = type('ADMINFLEET_CONFIG_REQUEST')
export const ADMINFLEET_CONFIG_SUCCESS = type('ADMINFLEET_CONFIG_SUCCESS')
export const ADMINFLEET_CONFIG_ERROR = type('ADMINFLEET_CONFIG_ERROR')

export const ADMINFLEET_ENSURE_CONFIG_LIST = type('ADMINFLEET_ENSURE_CONFIG_LIST')
export const ADMINFLEET_ENSURE_CONFIG_DETAIL = type('ADMINFLEET_ENSURE_CONFIG_DETAIL')

export const ADMINFLEET_CONFIG_DETAIL_REQUEST = type('ADMINFLEET_CONFIG_DETAIL_REQUEST')
export const ADMINFLEET_CONFIG_DETAIL_SUCCESS = type('ADMINFLEET_CONFIG_DETAIL_SUCCESS')
export const ADMINFLEET_CONFIG_DETAIL_ERROR = type('ADMINFLEET_CONFIG_DETAIL_ERROR')

export const ADMINFLEET_SAVE_CONFIG_REQUEST = type('ADMINFLEET_SAVE_CONFIG_REQUEST')
export const ADMINFLEET_SAVE_CONFIG_SUCCESS = type('ADMINFLEET_SAVE_CONFIG_SUCCESS')
export const ADMINFLEET_SAVE_CONFIG_ERROR = type('ADMINFLEET_SAVE_CONFIG_ERROR')

export const ADMINFLEET_SAVE_REQUEST = type('ADMINFLEET_SAVE_REQUEST')
export const ADMINFLEET_SAVE_SUCCESS = type('ADMINFLEET_SAVE_SUCCESS')
export const ADMINFLEET_SAVE_ERROR = type('ADMINFLEET_SAVE_ERROR')

export const ADMINFLEET_DELETE_REQUEST = type('ADMINFLEET_DELETE_REQUEST')
export const ADMINFLEET_DELETE_SUCCESS = type('ADMINFLEET_DELETE_SUCCESS')
export const ADMINFLEET_DELETE_ERROR = type('ADMINFLEET_DELETE_ERROR')

export const ADMINFLEET_UPDATE_MODIFIED_ADM = type('ADMINFLEET_UPDATE_MODIFIED_ADM')
export const ADMINFLEET_CANCEL_MODIFIED_ADM = type('ADMINFLEET_CANCEL_MODIFIED_ADM')

export const ADMINFLEET_UPDATE_FILTER_ADM = type('ADMINFLEET_UPDATE_FILTER_ADM')

export const ADMINFLEET_SHOW_HISTOCONFIG = type('ADMINFLEET_SHOW_HISTOCONFIG')
export const ADMINFLEET_HIDE_HISTOCONFIG = type('ADMINFLEET_HIDE_HISTOCONFIG')


export const ADMINFLEET_PUBLISH_IRIS_REQUEST = type('ADMINFLEET_PUBLISH_IRIS_REQUEST')
export const ADMINFLEET_PUBLISH_IRIS_SUCCESS = type('ADMINFLEET_PUBLISH_IRIS_SUCCESS')
export const ADMINFLEET_PUBLISH_IRIS_ERROR = type('ADMINFLEET_PUBLISH_IRIS_ERROR')


export const ADMINFLEET_SEND_COMMAND_IRIS_REQUEST = type('ADMINFLEET_SEND_COMMAND_IRIS_REQUEST')
export const ADMINFLEET_SEND_COMMAND_IRIS_SUCCESS = type('ADMINFLEET_SEND_COMMAND_IRIS_SUCCESS')
export const ADMINFLEET_SEND_COMMAND_IRIS_ERROR = type('ADMINFLEET_SEND_COMMAND_IRIS_ERROR')


export const ADMINFLEET_EXTERNAL_UPDATE = type('ADMINFLEET_EXTERNAL_UPDATE')

